



































import { Component, Vue, Watch } from "vue-property-decorator";

@Component
export default class StatusConfirmationDialog extends Vue {
  dialog = false;
  selectedStatus: number | null = null;

  @Watch("dialog")
  onDialogChanged(newValue: boolean) {
    if (!newValue) {
      // Reset when dialog is closed
      this.selectedStatus = null;
    }
  }

  show() {
    this.dialog = true;
    this.selectedStatus = null;
  }

  hide() {
    this.dialog = false;
  }

  cancel() {
    this.$emit("cancel");
    this.hide();
  }

  confirm() {
    if (this.selectedStatus) {
      this.$emit("confirm", this.selectedStatus);
      this.hide();
    }
  }
}
